
import Vue from 'vue'
import AppMixin from '@/_mixins/app'

import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'

const PSISettingsIndex = Vue.extend({
    mixins: [AppMixin],
    components: { ToolbarComponent },
    data() {
        return {
            authorized: false,
        }
    },

    mounted() {
        this.authorized = this.hasPermission(this.allPermissions, 'psi.admin')
    },
})
export default PSISettingsIndex
